import { FC } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import SmallTag from '@/shared/components/tags/SmallTag';

interface SyncingSmallTagProps {
    marginLeft?: string | number;
}

/** The canonical compact pending-persistence treatment used by sortable items. */
const SyncingSmallTag: FC<SyncingSmallTagProps> = ({ marginLeft = '0.5rem' }) => {
    const { token } = useAntDesignTheme();

    return (
        <SmallTag
            message={
                <span style={{ color: token.colorTextTertiary, padding: '0 0.125rem', whiteSpace: 'nowrap' }}>
                    <LoadingOutlined spin style={{ marginRight: '0.5rem' }} />
                    Syncing...
                </span>
            }
            styles={{ marginLeft }}
        />
    );
};

export default SyncingSmallTag;
